import { useSelector } from "react-redux";
import { leadGeneration, notify } from "../API/API";
import { showToast } from "../components/common/Util/Util";

export const useLeadGeneration = (setShowTalkToAdviser, setShowThankYouPopUp) => {
  const { user, ip, cordinates } = useSelector((state) => state.user);

  const handleLeadGeneration = () => {
    if (!user?.MobileNumber) {
      setShowTalkToAdviser(true);
      return;
    }

    const leadRequest = {
      mobileNumber: user.MobileNumber,
      leadType: "advisor",
      ip,
      longitude: String(cordinates?.lng || ""),
      latitude: String(cordinates?.lat || ""),
    };

    return leadGeneration(leadRequest)
      .then((res) => {
        if (res.statusCode === 200) {
          notify({
            userId: null,
            title: "New Lead Generated",
            content: `A new advisor lead has been generated by ${user.Name || user.name}.`,
            createdByRole: "USER",
            type: "leadGeneration",
            action: "View Lead",
            actionUrl: "/leads",
            unread: true,
          });
          setShowThankYouPopUp(true);
        } else {
          showToast("Oops! Something went wrong.", "error");
        }
      })
      .catch(() => showToast("Oops! Something went wrong.", "error"));
  };

  return handleLeadGeneration;
}; 
